import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import { TextBlock, MediaBlock, TextRow, RectShape, RoundShape } from 'react-placeholder/lib/placeholders';

export const Placeholder = (props) => {
  const history = useHistory();
  const { type } = props;

  if (type === 'media') {
    return (
      <article className='custom-placeholder'>
        <ReactPlaceholder showLoadingAnimation type={type} rows={4} ready={false}></ReactPlaceholder>
      </article>
    );
  } else if (type === 'text') {
    return (
      <article className='custom-placeholder'>
        <ReactPlaceholder showLoadingAnimation type={type} rows={4} ready={false}></ReactPlaceholder>
      </article>
    );
  } else if (type === 'round') {
    return (
      <article className='custom-placeholder'>
        <ReactPlaceholder
          showLoadingAnimation
          type={type}
          style={{ width: 50, height: 50 }}
          ready={false}
        ></ReactPlaceholder>
      </article>
    );
  } else {
    return null;
  }
};
